<template>
  <v-container grid-list-lg>
    <v-layout row wrap>

      <v-flex class="xs12 wrap">
        <div style="display: flex; align-items: center; ">
          <img :src="require('@/assets/nepaliport_logo.png')" alt="Avatar"
               style="width: 358px;">
        </div>

        <div class="mt-2" style="display: flex;">
          <div class="app-name-panel">New Trekking Request</div>
        </div>
      </v-flex>
      <v-flex lg12>
        <FormErrorDisplayHandler :errors="errors" class="mb-0"></FormErrorDisplayHandler>
        <v-card>
          <v-card-text>
            <v-form lazy-validation ref="formRef" v-model="valid">
              <v-layout row wrap>
                <v-flex xs12 class="ml-0">
                  <v-select
                      outlined
                      label="Select office *"
                      :rules="[rules.required]"
                      :items="offices"
                      item-value="value"
                      item-text="text"
                      v-model="trekkingData.office"
                  />
                </v-flex>
                <confirmation-header-text class="ml-0" icon="mdi-alpha-t-box"
                                          text="Trekking Route:"/>

                <v-flex class="pt-0" lg4 sm12>
                  <v-autocomplete
                      :items="trekkingRoutes"
                      :rules="[rules.required]"
                      item-text="name"
                      item-value="id"
                      label="Trekking Routes *"
                      outlined
                      return-object
                      v-model="trekkingData.trekkingRoute"
                  />
                </v-flex>

                <v-flex class="pt-0" lg4 sm12 v-if="trekkingData.trekkingRoute">
                  <v-text-field
                      :error-messages="noOfDaysError"
                      :min="trekkingData.trekkingRoute.min_days"
                      label="Number of days *"
                      outlined
                      type="number"
                      v-model="trekkingData.no_of_days"
                      onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"

                  />
                </v-flex>

                <v-flex class="pt-0" lg4 sm12>
                  <outlined-time-picker :rules="[rules.required,rules.afterTodayEng]"
                                        label="Start Date (AD) *"
                                        v-model="trekkingData.starting_date"/>
                </v-flex>

                <v-flex class="pt-0" sm12>
                  <v-simple-table v-if="trekkingData.trekkingRoute">
                    <thead>
                    <tr>
                      <th class="text-left" v-for="header in headers">{{ header.text }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="item.name" v-for="item in trekkingData.trekkingRoute.extra.pricing">
                      <td>{{ months[item.from_month - 1] }}</td>
                      <td>{{ months[item.to_month - 1] }}</td>
                      <td>{{ trekkingData.trekkingRoute.min_days }}</td>
                      <td>USD {{ item.min_days_rate }}</td>
                      <td>USD {{ item.extend_per_day }}</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-flex>

                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <confirmation-header-text class="ml-0" icon="mdi-account"
                                                text="Trekker's Info:"/>
                    </v-flex>
                    <v-flex xs6>
                      <v-btn @click="increaseTrekker" class="pull-right"
                             color="primary white--text" fab
                             x-small>
                        <v-icon>add</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-layout row wrap v-for="(traveller,index) in travellers">
                  <v-flex :class="index > 1 ? 'xs6' : 'xs12'" v-if="index !== 0">
                    <confirmation-header-text class="ml-0" icon="mdi-account"
                                              text="Trekker's Info:"/>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                        label="Indian without visa"
                        v-model="traveller.indian_without_visa"
                        :value="1"
                    />
                  </v-flex>
                  <v-flex xs12 v-if="index > 0">
                    <v-spacer/>
                    <v-btn @click="decreaseTraveller(index)" class="pull-right"
                           color="red white--text" fab
                           x-small>
                      <v-icon>remove</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-layout v-if="traveller.indian_without_visa" class="pl-2" row wrap>
                    <v-flex md6 xs12>
                      <v-text-field
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          label="Full Name *"
                          :rules="[rules.required]"
                          outlined
                          type="text"
                          v-model="traveller.full_name"
                      />
                    </v-flex>
                    <v-flex md6 xs12 class="pr-8">
                      <new-date-picker
                          :type="'dob'"
                          min-year="1900"
                          label="Date of birth(AD) *"
                          v-model="traveller.dob"
                          :max-year="max_year"
                      />
                    </v-flex>


                    <v-flex md6 xs12>
                      <v-text-field
                          label="Email (Optional) "
                          outlined
                          type="email"
                          v-model="traveller.email"
                      />
                    </v-flex>


                    <v-flex md6 xs12>
                      <v-select
                          :items="genders"
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          label="Gender *"
                          :rules="[rules.required]"
                          outlined
                          v-model="traveller.gender"
                      />
                    </v-flex>

                    <v-flex md6 xs12>
                      <v-combobox
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :items="occupations"
                          label="Select Occupation *"
                          :rules="[rules.required]"
                          outlined
                          v-model="traveller.occupation"
                      />
                    </v-flex>

                    <v-text-field v-if="traveller.indian_without_visa"
                                  class="pr-4"
                                  :label="'Address of India *'"
                                  :rules="[rules.required]"
                                  outlined
                                  v-model="traveller.full_address"
                    ></v-text-field>

                    <v-flex md6 xs12 v-else>
                      <v-text-field
                          :rules="[rules.required]"
                          :label="'Address of '+getCountryName(traveller.country_id)+' *'"
                          v-model="traveller.full_address"
                          outlined
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex md6 xs12>
                      <v-text-field
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :label="traveller.indian_without_visa?'Contact no of India':'Contact no of '+getCountryName(traveller.country_id)+' *'"
                          :prefix="traveller.indian_without_visa ?'+91':getCountryStdCode(traveller.country_id)||'+000'"
                          :rules="[rules.required, rules.international_number]"
                          min="0"
                          outlined
                          type="number"
                          onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                          v-model="traveller.contact_no"
                      />
                    </v-flex>

                    <v-flex md6 transition="scale-transition" xs12>
                      <file-input
                          label="User Photo *"
                          v-model="traveller.user_image"
                          :required="true"
                      />
                    </v-flex>

                    <v-flex md6 xs12 v-if="traveller.indian_without_visa">
                      <file-input
                          label="Recommendation Letter *"
                          v-model="traveller.recommendation_letter"
                          :required="true"
                      />
                    </v-flex>

                    <confirmation-header-text class="ml-0" icon="mdi-passport"
                                              text="Document Detail:"/>

                    <v-flex md6 xs12 v-if="traveller.indian_without_visa">
                      <v-autocomplete
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :items="document_types"
                          label="Document Type *"
                          :rules="[rules.required]"
                          outlined
                          v-model="traveller.passport.passport_type"
                          id="passportType"
                      />
                    </v-flex>
                    <v-flex md6 xs12 v-else>
                      <v-autocomplete
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :items="getDocumentTypes(traveller.country_id)"
                          label="Document Type *"
                          :rules="[rules.required]"
                          outlined
                          v-model="traveller.passport.passport_type"
                          id="passportType"
                      />
                    </v-flex>
                    <v-flex md6 transition="scale-transition" xs12>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Document number *"
                          outlined
                          type="text"
                          v-model="traveller.passport_number"
                      />
                    </v-flex>

                    <v-flex md6 xs12 v-if="showValidity(traveller.passport.passport_type)">
                      <new-date-picker
                          :type="'passport'"
                          :maxYear=getYearPreviousOrAfterCurrent(14)
                          :minYear=getCurrentYearsubtwo()
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          label="Document Validity Date *"
                          v-model="traveller.passport.validity"
                      />
                    </v-flex>
                    <v-flex md6 xs12
                            :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    >
                      <file-input label="Document Image *"
                                  :required="true"
                                  v-model="traveller.passport.passport_image"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-else class="pl-2">
                    <v-flex :key="index+'submission_no'" md6 transition="scale-transition" xs12>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Visa Number/Submission ID *"
                          outlined
                          type="text"
                          v-model="traveller.visa_number"
                      />
                    </v-flex>
                    <v-flex :key="index+'passport_number'" md6 transition="scale-transition" xs12 class="pr-4">
                      <v-text-field
                          :rules="[rules.required]"
                          label="Passport number *"
                          outlined
                          type="text"
                          v-model="traveller.passport_number"
                      />
                    </v-flex>
                    <v-flex md6 xs12 :key="index+'recommendation_letter'">
                      <file-input
                          label="Recommendation Letter *"
                          v-model="traveller.recommendation_letter"
                          :required="true"
                      />
                    </v-flex>
                  </v-layout>
                  <v-flex xs12>
                    <v-divider/>
                  </v-flex>
                </v-layout>

              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-3">
            <v-spacer/>
            <v-btn @click="proceed" color="blue darken-2" dark>Proceed</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Http from "axios";
import {API_URL, VERSION, API_VERSION} from "../../config/config.js";
import FileInput from '../../components/FileInput'
import ConfirmationHeaderText from '../../components/ConfirmationHeaderText'
import FormErrorDisplayHandler from '../../components/FormErrorDisplayHandler'
import OutlinedTimePicker from "../../components/OutlinedDatePicker";
import AddressAutoComplete from "../../components/trekkingRequest/AddressAutoComplete";
import {validationMixin} from "../../mixins/validationMixin";
import {passportTypes} from "../../constant/appConstant";
import NewDatePicker from "@/components/NewDatePicker";
import moment from "moment";

export default {
  data: () => ({
    valid: true,
    headers: [
      {
        text: 'From Month',
        value: 'From month'
      },
      {
        text: 'To Month',
        value: 'To month'
      },
      {
        text: 'Min Days',
        value: 'Min Days rate'
      },
      {
        text: 'Min Cost',
        value: 'Min Cost'
      },
      {
        text: 'Extend Rate Per Day',
        value: 'Extended per day'
      },
    ],
    max_year: new Date().toISOString().substr(0, 4),
    trekkingRoutes: [],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    errors: [],
    occupations: [],
    stdCode: '000',
    countryCode: null,
    currentCountryName: 'Country',
    genders: [
      'Male', 'Female', 'Rather not say'
    ],
    passportTypes,
    offices: [{
      text: 'Kathmandu',
      value: 'doi'
    },
      {
        text: 'Pokhara',
        value: 'io03'
      }],
    document_types: ['Ordinary passport','Diplomatic Passport','Official/Service Passport', 'Rasan card', 'Voter Id']
  }),
  mixins: [validationMixin],
  components: {
    FormErrorDisplayHandler,
    ConfirmationHeaderText,
    OutlinedTimePicker,
    'file-input': FileInput,
    AddressAutoComplete,
    NewDatePicker
  },
  computed: {
    ...mapGetters({
      countries: "SingleTrekRequest/countries"
    }),
    trekkingData: {
      get() {
        return this.$store.state.SingleTrekRequest.trekkingData;
      },
      set(value) {
        this.$store.commit('SingleTrekRequest/setTrekkinData', value)
      }
    },
    travellers() {
      return this.$store.state.SingleTrekRequest.travellers;
    },
    noOfDaysError() {
      let error = 'Required';

      if (this.trekkingData.no_of_days) {
        if (Number(this.trekkingData.no_of_days) < Number(this.trekkingData.trekkingRoute.min_days)) {
          error = 'No of days cannot be less than ' + this.trekkingData.trekkingRoute.min_days;
        } else {
          error = '';
        }
      }

      return error;
    },
  },
  methods: {
    ...mapActions("SingleTrekRequest", ["resetTrekRequestState", "checkSingleVisaValidity", "getCountries"]),
    getCurrentYearsubtwo() {
      let currentYear = Number(new Date().toISOString().substr(0, 4)) - 2;
      return parseInt(currentYear);
    },
    getYearPreviousOrAfterCurrent(value) {
      let currentYear = new Date().toISOString().substr(0, 4);
      return parseInt(currentYear) + value;
    },
    increaseTrekker() {
      this.$store.commit('SingleTrekRequest/addTraveller');
    },
    decreaseTraveller(index) {
      this.$store.commit('SingleTrekRequest/removeTraveller', index);
    },
    async proceed() {
      let last_date = moment(this.trekkingData.starting_date).add(this.trekkingData.no_of_days, "days").format("YYYY-MM-DD");
      if (this.$refs.formRef.validate() && this.noOfDaysError === '') {
        let extra_data = {
          last_date: last_date
        };
        let getErrors = await this.checkSingleVisaValidity(extra_data);

        if (getErrors.length > 0) {
          this.loading = false;
          this.$store.commit("Notification/showError", 'Invalid form data');
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

          this.errors = getErrors;
        } else {
          this.$router.push({name: "SingleTrekkingRequestConfirm"});
        }
      } else {
        this.$store.commit("Notification/showError", 'Invalid form data');
      }
    },
    getAllTrekkingRoutes() {
      Http.get(API_URL + VERSION + "/trekking-routes/fetch-all")
          .then(response => {
            this.trekkingRoutes = response.data.data;
          })

    },
    fetchOccupations() {
      Http.get(`${API_URL}${API_VERSION}` + '/dynamic-values-setup/fetch-all?key=occupations').then((response) => {
        this.occupations = response.data.map((item) => item.value).map(i => i.name);
        this.occupations.push('others')
      })
    },
    getCountryCode(country_id) {
      const country = this.countries.find(n => n.id === country_id);
      return country === undefined ? '' : country.code;
    },
    getCountryStdCode(country_id) {
      const country = this.countries.find(n => n.id === country_id);
      return country === undefined ? '' : country.std_code;
    },
    getCountryName(country_id) {
      const country = this.countries.find(n => n.id === country_id);
      return country === undefined ? '' : country.country_name;
    },
    getDocumentTypes(country_id) {
      const country = this.countries.find(i => i.id === country_id);
      let passportTypes = this.passportTypes.filter(i => i !== 'Other Travel Document').map(i => i === 'Ordinary' ? i + ' passport' : i + ' Passport');
      if (country === undefined)
        return passportTypes;

      if (country.code === 'IND') {
        passportTypes.push('Rasan card');
        passportTypes.push('Voter id')
      }
      return passportTypes;
    },
    countrySelected() {
      let nationality = this.countries.find(n => n.id === this.travellerData.country_id);
      this.stdCode = nationality.std_code;
      this.currentCountryName = nationality.country_name;
      this.countryCode = nationality.code;
    },
    showValidity(document_type) {
      if (!document_type)
        return true;

      return document_type.split(" ").includes("passport") || document_type.split(" ").includes("Passport");
    }
  },
  mounted() {
    this.getAllTrekkingRoutes();
    this.getCountries();
    this.fetchOccupations();
  }
}
</script>
